import React, { useMemo } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Sparkles } from "lucide-react";

export default function TeamsNoData({ search, onCreateTeam }) {
  const theme = useTheme();
  const refId = useMemo(() => Math.floor(Math.random() * 9000) + 1000, []);

  return (
    <Box
      sx={{
        minHeight: '60vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/2c7fe329-f49d-4dbe-a937-1aa2f6396dca/bIG2AKICQe.lottie"
          loop
          autoplay
        />
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 1,
            letterSpacing: '-0.02em',
          }}
        >
          {search ? 'No teams found' : 'No teams yet'}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            mb: 3,
          }}
        >
          {search
            ? 'Create your first team to get started'
            : 'Create your first team to get started'}
        </Typography>

        {!search && (
          <Button
            onClick={onCreateTeam}
            variant="contained"
            startIcon={<Sparkles size={18} />}
            sx={{
              px: 4,
              py: 1.25,
              fontWeight: 600,
              borderRadius: 2,
              background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.25)}`,
              color: '#fff',
            }}
          >
            Create Your First Team
          </Button>
        )}
      </Box>

      {/* <Box
        sx={{
          position: 'absolute',
          bottom: 40,
          display: 'flex',
          gap: 3,
          opacity: 0.3,
        }}
      >
        <Typography
          sx={{ fontFamily: 'monospace', fontSize: '10px', fontWeight: 700 }}
        >
          CODE: 404_EMPTY
        </Typography>
        <Typography
          sx={{ fontFamily: 'monospace', fontSize: '10px', fontWeight: 700 }}
        >
          TRACE_ID: {refId}
        </Typography>
      </Box> */}
    </Box>
  );
}
